


























































































































import { computed, defineComponent, ref, watchEffect } from '@vue/composition-api';
import axios from 'axios';

import { login, isClient } from '@/api';
import { loggedIn, saveCookie } from '@/utils/auth';
import store from '@/store';
import { APP_NAME, SERVER_URL } from '@/environment';

export default defineComponent({
  name: 'Login',
  setup(props, ctx) {
    // NOTE: May need to be computed ref
    const router = ctx.root.$router;

    const username = ref<string | null>(null);
    const password = ref<string | null>(null);
    const showPassword = ref(false);
    const loginErrorMessage = ref<string | null>(null);
    const emailVerified = ctx.root.$route.query.verified === '1';
    const forgotPasswordDialog = ref(false);
    const resetEmail = ref('');
    const resetEmailError = ref('');
    const resetMessage = ref('');
    const requestingPasswordReset = ref(false);
    const validResetEmail = computed(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(resetEmail.value.trim()));

    async function loginUser() {
      if (username.value && password.value) {
        const resp = await login(SERVER_URL, username.value, password.value);

        if (isClient(resp)) {
          saveCookie({ url: resp.serverURL });
          store.commit.setClient(resp);
        } else {
          loginErrorMessage.value = resp;
        }

        username.value = null;
        password.value = null;
      }
    }

    async function requestPasswordReset() {
      if (!validResetEmail.value) {
        resetEmailError.value = 'Enter a valid email address';
        return;
      }
      requestingPasswordReset.value = true;
      resetEmailError.value = '';
      resetMessage.value = '';
      try {
        const response = await axios.post(`${SERVER_URL}/auth/password-reset/request`, {
          email: resetEmail.value.trim().toLowerCase(),
        });
        resetMessage.value = response.data;
      } catch (error) {
        const response = (error as { response?: { data?: string } }).response;
        resetEmailError.value = response?.data || 'Unable to send a reset link; please try again later.';
      } finally {
        requestingPasswordReset.value = false;
      }
    }

    // Route unverified legacy accounts to the verification screen instead of
    // allowing them into the application workspace.
    watchEffect(() => {
      if (loggedIn.value) {
        router.push(store.state.client?.user?.email_verified ? '/app' : '/email-verification');
      }
    });

    return {
      APP_NAME,
      SERVER_URL,
      loginUser,
      loginErrorMessage,
      username,
      password,
      showPassword,
      emailVerified,
      forgotPasswordDialog,
      requestingPasswordReset,
      requestPasswordReset,
      resetEmail,
      resetEmailError,
      resetMessage,
      validResetEmail,
    };
  },
});
